import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import ViewModal from './_modals/view';
import OnHold from './_modals/onHold';
import Loader from '../../_components/loader';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';
const moment = require('moment');

const getAdminCpd_Url = AdminUrls.ADMIN.CPDACCREDITED;
const approveCpd_Url = AdminUrls.ADMIN.CPDACCREDITEDAR;
const cpdQueueUpdate_Url = AdminUrls.ADMIN.CPDQUEUEUPDATE;
const cpdQueuegetComments_Url = AdminUrls.COMMON.GETCPDQUEUECOMMENTS;
const downloadFiles_Url = AdminUrls.ADMIN.CPDACCRDFDOWNLOAD;

class AccredAdmin extends React.Component {
  constructor() {
    super();
    // moment(dashboard_record.userCompletionDate).format("ll")
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.getLoadCpd = this.getLoadCpd.bind(this);
    this.searchCpdData = this.searchCpdData.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.selectCpdHandler = this.selectCpdHandler.bind(this);
    this.approvedCpdHandler = this.approvedCpdHandler.bind(this);
    this.rejectCpdHandler = this.rejectCpdHandler.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleCPDQueueUpdate = this.handleCPDQueueUpdate.bind(this);
    this.handleCommentsChange = this.handleCommentsChange.bind(this);
    this.getCommentListData = this.getCommentListData.bind(this);

    this.state = {
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,

      listViewModalShown: false,
      listViewDataCourseName: '',
      listViewDatastartDate: '',
      listViewDatacourseLocation: '',
      listViewDatacourseType: '',
      listViewDatahost: '',
      listViewDatacpdFormat: '',
      listViewDatavenue: '',
      listViewDatatrainer: '',
      listViewDatacourseDescription: '',

      listOnHoldShown: false,
      listViewDataComments: '',

      sort: {
        column: '',
        direction: '',
      },

      cpdUserName: '',
      cpdHostName: '',
      cpdCourseName: '',
      mainLoading: false,
      loadCpd: '',
      selectIdHandler: [],
      dupLoadCpd: [],
      emptyDivMsg: 'There is no data to show in the grid.',
    };
    this.controller = new AbortController();
  }

  componentDidMount() {
    this.getLoadCpd(1);
  }

  clearSearchFilters() {
    this.setState(
      {
        cpdUserName: '',
        cpdHostName: '',
        cpdCourseName: '',
      },
      () => {
        this.getLoadCpd(this?.state?.activePage);
      }
    );
  }

  openModalWithItem(id) {
    let dup = this.state?.loadCpd?.Items;

    let found = dup.find((x) => x.ID === id);

    if (found.ID === id) {
      this.setState({
        listViewDataCourseName: found.Name,
        listViewDatastartDate: found.StartDate,
        listViewDatacourseLocation: found.LocationName,
        listViewDatacourseType: found.CPDTypeDesc ? found.CPDTypeDesc : 'na',
        listViewDatahost: found.HostName ? found.HostName : 'na',
        listViewDatacpdFormat: found.CPDFormatName ? found.CPDFormatName : 'na',
        listViewDatavenue: found.Venue ? found.Venue : 'na',
        listViewDatatrainer: found.Trainer ? found.Trainer : 'na',
        listViewDatacourseDescription: found.Description
          ? found.Description
          : 'na',
        listViewModalShown: true,
      });
    }
  }

  openOnHoldModalWithItem(id) {
    this.getCommentListData(id);
    let dup = this.state?.loadCpd?.Items;
    let found = dup.find((x) => x.ID === id);
    if (found.ID === id) {
      this.setState({
        listViewId: found.ID,
        listViewDataCourseName: found.Name,
        listOnHoldShown: true,
        listViewDataComments: '',
      });
    }
  }

  getCommentListData(Id) {
    axios
      .get(cpdQueuegetComments_Url + '?ID=' + Id, {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          listViewCommentList: data,
        });
        this.setState({
          listOnHoldShown: true,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  getLoadCpd(pageNumber) {
    this.setState({
      mainLoading: true,
    });

    let sort = this.state.sort.column;
    let reverse = this.state.sort.direction;
    let name = this.state.cpdCourseName;
    let user_name = this.state.cpdUserName;
    let hostName = this.state.cpdHostName;

    let obj = {
      page: pageNumber,
      pageSize: this?.state?.per_page,
    };

    if (sort) {
      obj.sortBy = sort;
    }
    if (reverse) {
      reverse = reverse === 'asc' ? false : true;
      obj.reverse = reverse;
    }

    if (name) {
      obj.Name = name;
    }

    if (user_name) {
      obj.UserName = user_name;
    }
    if (hostName) {
      obj.Provider = hostName;
    }

    axios
      .get(getAdminCpd_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          totalPages: data?.TotalPages,
          totalCount: data?.TotalCount,
          activePage: data?.Page,
          loadCpd: data,
          dupLoadCpd: data,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  searchCpdData() {
    this.setState({
      mainLoading: true,
    });

    this.getLoadCpd(this?.state?.activePage);
  }

  downloadFile(name) {
    if (name && name.toUpperCase() !== 'NO FILE UPLOADED') {
      var downloadPath = downloadFiles_Url + '?name=' + name;
      window.open(downloadPath, '_blank', '');
    }
  }

  selectCpdHandler(id) {
    let dupArr = this.state.selectIdHandler;

    let found = dupArr.find((x) => x === id);
    if (found) {
      return false;
    } else {
      dupArr.push(id);
      this.setState({
        selectIdHandler: dupArr,
      });
    }
  }

  handleCommentsChange(e) {
    this.setState({
      listViewDataComments: e,
    });
  }

  handleCPDQueueUpdate() {
    let obj = {
      ID: this.state.listViewId,
      Status: 8,
      Comments: this.state.listViewDataComments,
    };
    axios
      .post(cpdQueueUpdate_Url, obj, {
        method: 'POST',
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        NotificationManager.success(
          'Request for further info sent successfully'
        );
        this.getLoadCpd(1);
        this.setState({
          mainLoading: false,
          listOnHoldShown: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  approvedCpdHandler() {
    this.setState({
      mainLoading: true,
    });
    let obj = {
      Ids: this.state?.selectIdHandler,
      Status: 3,
    };
    axios
      .post(approveCpd_Url, obj, {
        method: 'POST',
        withCredentials: true,
        signal: this.controller.signal,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          mainLoading: false,
        });
        NotificationManager.success('Approved Successfully!');
        this.getLoadCpd(1);
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }
  rejectCpdHandler() {
    this.setState({
      mainLoading: true,
    });
    let obj = {
      Ids: this.state?.selectIdHandler,
      Status: 1,
    };
    axios
      .post(approveCpd_Url, obj, {
        method: 'POST',
        withCredentials: true,
        signal: this.controller.signal,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        NotificationManager.success('Reject Successfully');
        this.getLoadCpd(1);
        this.setState({
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.getLoadCpd(pageNumber);
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState(
      {
        sort: {
          column,
          direction,
        },
      },
      () => {
        this.getLoadCpd(this.state.activePage);
      }
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let listViewModalShownClose = () =>
      this.setState({ listViewModalShown: false });
    let listOnHoldShownClose = () => this.setState({ listOnHoldShown: false });
    let loadCpds;

    if (this.state.loadCpd !== null) {
      loadCpds = this.state.loadCpd?.Items?.map((cpdItem, index) => {
        return (
          <tr key={index}>
            <td>
              <input
                type="checkbox"
                value={cpdItem.ID}
                onChange={() => this.selectCpdHandler(cpdItem.ID)}
              />
            </td>
            <td>{cpdItem?.Name}</td>
            <td>{cpdItem?.TotalDuration}h</td>
            <td>{moment(cpdItem?.SubmittedDate).format('ll')}</td>
            <td>{cpdItem?.HostName}</td>
            {!cpdItem?.FileName || cpdItem?.FileName === 'No File Uploaded' ? (
              <td>{null}</td>
            ) : (
              <td>
                {' '}
                <button
                  onClick={() => this.downloadFile(cpdItem.ModifiedFileName)}
                  className="button-custom"
                >
                  <i className="fa fa-files-o"></i>
                </button>
              </td>
            )}
            <td>{cpdItem.UserName}</td>
            <td>
              <a href={`mailto:${cpdItem.Email}`}>{cpdItem.Email}</a>
            </td>
            <td>
              <input
                type="checkbox"
                onChange={() => this.selectCpdHandler(cpdItem.ID)}
              />
            </td>
            <td>
              <button
                onClick={() => this.openModalWithItem(cpdItem.ID)}
                className="button-custom"
              >
                <i className="fa fa fa-eye"></i>
              </button>
            </td>
            <td>
              <button
                onClick={() => this.openOnHoldModalWithItem(cpdItem.ID)}
                className="button-custom"
              >
                <i className="fa fa-plus"></i>
              </button>
            </td>
            <td>
              {cpdItem?.WorkflowStepId === 8 && (
                <i
                  title="Waiting for further info"
                  className="fa fa-clock-o"
                  style={{ fontSize: '20px', cursor: 'pointer' }}
                ></i>
              )}
              {cpdItem?.WorkflowStepId === 9 && (
                <i
                  title="Information received"
                  className="fa fa-bell-o"
                  style={{ fontSize: '20px', cursor: 'pointer' }}
                ></i>
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              ></i>
            </div>

            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group admin-accredadmin-forms">
                        <label>User Name</label>
                        <input
                          type="username"
                          className="form-control"
                          id="username"
                          value={this.state.cpdUserName}
                          onChange={(e) =>
                            this.setState({ cpdUserName: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              this.searchCpdData()
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group admin-accredadmin-forms">
                        <label>Host Name</label>
                        <input
                          type="hostname"
                          className="form-control"
                          id="hostname"
                          value={this.state.cpdHostName}
                          onChange={(e) =>
                            this.setState({ cpdHostName: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              this.searchCpdData()
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group admin-accredadmin-forms">
                        <label>Course Name</label>
                        <input
                          type="course name"
                          className="form-control"
                          value={this.state.cpdCourseName}
                          id="course name"
                          onChange={(e) =>
                            this.setState({ cpdCourseName: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              this.searchCpdData()
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-success"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchCpdData}
                    >
                      Search
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={() => this.clearSearchFilters()}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-table-accredadmin">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th></th>
                <th onClick={this.onSort('Name')}>
                  Course
                  <i className={this.setArrow('Name')}> </i>
                </th>
                <th onClick={this.onSort('TotalDuration')}>
                  Duration
                  <i className={this.setArrow('TotalDuration')}> </i>
                </th>
                <th onClick={this.onSort('SubmittedDate')}>
                  Submitted Date
                  <i className={this.setArrow('SubmittedDate')}> </i>
                </th>
                <th onClick={this.onSort('HostName')}>
                  Host
                  <i className={this.setArrow('HostName')}> </i>
                </th>
                <th>Attachment</th>
                <th onClick={this.onSort('UserName')}>
                  User
                  <i className={this.setArrow('UserName')}> </i>
                </th>

                <th>Email Address</th>
                <th>Publish</th>
                <th></th>
                <th colSpan={2}></th>
              </tr>
            </thead>
            <tbody>{loadCpds}</tbody>
          </table>
          {loadCpds?.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            firstPageText="First"
            lastPageText="Last"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>

        <div className="row">
          <div className="gridTopButtons" style={{ paddingTop: '15px' }}>
            <button
              className="btn btn-success"
              style={{ marginRight: '10px' }}
              onClick={this.approvedCpdHandler}
            >
              Accept
            </button>
            <button className="btn btn-danger" onClick={this.rejectCpdHandler}>
              Reject
            </button>
          </div>
        </div>

        <ViewModal
          show={this.state.listViewModalShown}
          onHide={listViewModalShownClose}
          startdate={this.state.listViewDatastartDate}
          coursename={this.state.listViewDataCourseName}
          courselocation={this.state.listViewDatacourseLocation}
          coursetype={this.state.listViewDatacourseType}
          host={this.state.listViewDatahost}
          cpdformat={this.state?.listViewDatacpdFormat}
          venue={this.state.listViewDatavenue}
          trainer={this.state.listViewDatatrainer}
          description={this.state.listViewDatacourseDescription}
        />
        <OnHold
          id={this.state.listViewId}
          coursename={this.state.listViewDataCourseName}
          comments={this.state.listViewDataComments}
          show={this.state.listOnHoldShown}
          onHide={listOnHoldShownClose}
          handleCPDQueueUpdate={this.handleCPDQueueUpdate}
          handleCommentsChange={this.handleCommentsChange}
          commentList={this.state.listViewCommentList}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccredAdmin);
